import React, { useEffect, useState } from "react";
import LeftMenu from "../../../components/layout/leftMenu";
import Header from "../../../components/layout/header";
import { ToastContainer } from "react-toastify";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import CreateJobOpening from "./createJobOpening";
import JobOpeningHistory from "./jobOpeningHistory";

export default function NewRequirmentMainPage() {
  const [menuClick, setMenuClick] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      document.getElementById("NewVacancyMenu").classList.add("active");
    }, 500);
  });

  const toggleMenu = () => {
    setMenuClick(!menuClick);
  };
  const closeMenu = () => {
    setMenuClick(false);
  };

  return (
    <div className="main-wrapper">
      <div className="top-color"></div>
      <ToastContainer
        enableMultiContainer
        containerId={"D"}
        position="bottom-right"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <LeftMenu menuClick={menuClick} closeMenu={closeMenu} />
      <div className="content-wrapper">
        <Header
          Header="New Requirement"
          toggleMenu={toggleMenu}
          menuClick={menuClick}
        />
        <div className="card main-card">
          <div className="card-body">
            <Tabs
            //   selectedIndex={tabIndex}
            //   onSelect={(index) => {
            //     setTabIndex(index);
            //     console.log("🚀 ~ Newrequirement ~ index:", index);
            //   }}
            >
              <TabList>
                <Tab>New Requirement</Tab>
                <Tab>History</Tab>
              </TabList>
              <TabPanel>
                <CreateJobOpening />
              </TabPanel>
              <TabPanel>
                <JobOpeningHistory />
              </TabPanel>
            </Tabs>
          </div>
        </div>
      </div>
    </div>
  );
}
